import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSubscriptionFreeze } from './SubscriptionFreezeContext';
import { freezeLocksPath } from './freezeLock';
import { FREEZE_STATUS_PATH } from './paths';

/** Sends billing to the pause while one is open; every other page renders at once, paused or not. */
export default function SubscriptionFreezeRouteGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { freeze, loading } = useSubscriptionFreeze();

  if (!freezeLocksPath(location.pathname)) return <>{children}</>;
  if (loading) {
    return (
      <Box minHeight="60vh" display="grid" sx={{ placeItems: 'center' }}>
        <CircularProgress size={28} aria-label="Checking subscription status" />
      </Box>
    );
  }
  if (freeze) {
    return <Navigate replace to={FREEZE_STATUS_PATH} state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
